import { gql } from '@apollo/client';

export const GET_DEVICE_TYPES = gql`
  query GetDeviceTypes {
    getDeviceTypes {
      AHS
      NZM
    }
  }
`;
